import { useEffect } from 'react';

type Options = {
  isActive: boolean;
  isInsideSelectors: string[]; // CSS селекторы элементов, клики по которым считаем «внутри»
  onClose: () => void;
};

export function useCloseOnOutsideOrEsc({ isActive, isInsideSelectors, onClose }: Options) {
  useEffect(() => {
    if (!isActive) return;

    const clickListener = (event: MouseEvent) => {
      event.stopPropagation();
      const target = event.target as HTMLElement | null;
      if (!target) return;

      // Кликнутый узел мог исчезнуть из DOM ещё до того, как клик дошёл до document:
      // React успевает перерисовать поддерево внутри обработки того же клика. По оторванному
      // узлу нельзя понять, был клик внутри или снаружи, — считаем, что закрывать нечего.
      if (!target.isConnected) return;

      const isInside = isInsideSelectors.some((sel) => !!target.closest(sel));
      if (!isInside) onClose();
    };

    const keyListener = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('click', clickListener);
    document.addEventListener('keydown', keyListener);

    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keydown', keyListener);
    };
  }, [isActive, isInsideSelectors, onClose]);
}
